import React from 'react';
import { userService } from 'Services';
import LoadingPageContent from 'Components/LoadingPageContent';
import ErrorContent from 'Components/ErrorContent';

function withAuthenticatedUser(WrappedComponent) {
    class WithAuthenticatedUser extends React.Component {
        constructor(props)  {
            super(props);

            this.state = {
                authenticatedUser: '',
                error: null
            }
        }

        componentDidMount() {

            var self = this;

            userService.getUser()
                .then(response => {
                    var user = response;

                    this.setState({
                        authenticatedUser: user
                    });
                })
                .catch(error => {
                    console.log(error);
                    
                    if (error.status === 401) {
                        this.props.router.navigate('/login');
                    }

                    this.setState({
                        error: error
                    });
                    
                });
        }

        render() {

            if (this.state.error)
                return (<ErrorContent error={this.state.error} />);

            if (!this.state.authenticatedUser)
                return (<LoadingPageContent />);

            return (<WrappedComponent {...this.props} authenticatedUser={this.state.authenticatedUser}/>);
        }
    }

    WithAuthenticatedUser.displayName = `WithAuthenticatedUser(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

    return WithAuthenticatedUser;
}

export { withAuthenticatedUser };